import { types } from './actions';

export const initialState = {
	triggers: null,
	errorDetail: null,
	currentState: 'stable'
};

export const triggers = (state, action) => {
	state = state || initialState;
	switch (action.type) {
		case types.FETCH_TRIGGERS:
			return {
				...state,
				triggers: null,
				status: 'loading'
			};
		case types.FETCH_TRIGGERS_SUCCESS:
			return {
				...state,
				triggers: action.payload,
				status: 'stable'
			};
		case types.FETCH_TRIGGERS_ERROR:
			return {
				...state,
				status: 'error',
				errorDetail: action.payload
			};
		default:
			return state;
	}
};
